import {mapMutations, mapActions} from 'vuex'

export const pageSettings = {
  methods: {
    ...mapMutations({
      setFullSidebar: 'sidebar/SET_DASHBOARD',
      setLinkName: 'sidebar/SET_LINK_NAME',
      setRouteName: 'sidebar/SET_ROUTE_NAME'
    }),
    ...mapActions({
      getUsers: 'roles/getUsers',
      getRoles: 'roles/getOwnedRoles',
      getInvitedUsers: 'roles/getInvitedUsers',
    })
  }
}
